import { Button } from 'primereact/button';
import './App.css';
import './PageMarketingV2GDPR.css';
import { useState } from 'react';

function PageMarketingV2GDPR() {
    const [didAccept, setDidAccept] = useState(localStorage.getItem('did_accept'));

    if (didAccept) {
        return null;
    }

    return (
        <div className='gdpr'>
            <div className='gdpr-body'>
                <div style={{ width: '100%' }}>
                    We use essential cookies. We also have other cookies for a better website experience.
                </div>
                <div
                    style={{
                        marginLeft: 'auto',
                        width: 'min-content',
                    }}
                >
                    <Button
                        label='Allow'
                        severity='secondary'
                        outlined
                        size='small'
                        onClick={() => {
                            localStorage.setItem('did_accept', true);
                            setDidAccept(true);
                        }}
                    />
                </div>
            </div>
        </div>
    );
}

export default PageMarketingV2GDPR;